import { cn } from '@/lib/utils'

export function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden
      className={cn(
        'animate-shimmer rounded-md bg-muted bg-[linear-gradient(90deg,transparent_0%,color-mix(in_oklch,var(--foreground)_6%,transparent)_50%,transparent_100%)] bg-[length:800px_100%] bg-no-repeat',
        className,
      )}
      {...props}
    />
  )
}
